import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, ShieldCheck, DollarSign, Wifi } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-bg" />

      <div className="hero-container">

        <motion.div
          className="hero-eyebrow"
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <span className="hero-eyebrow-dot" />
          Telehealth · Accessible · Affordable
        </motion.div>

        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.25 }}
        >
          Healthcare that comes{' '}
          <span className="hero-title-accent">to you</span>
        </motion.h1>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
        >
          Quality medical care from the comfort of your home — no waiting rooms,
          no travel, no hassle. Transparent pricing starting at $25.
        </motion.p>

        <motion.div
          className="hero-actions"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.6 }}
        >
          <motion.button
            type="button"
            onClick={scrollToServices}
            className="hero-btn-primary"
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
          >
            Explore services <ChevronRight size={18} />
          </motion.button>
          <Link to="/contact" className="hero-btn-secondary">
            Contact us
          </Link>
        </motion.div>

        <motion.div
          className="hero-trust"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.8 }}
        >
          <div className="hero-trust-item">
            <ShieldCheck size={15} className="hero-trust-icon" />
            <span>Licensed providers</span>
          </div>
          <span className="hero-trust-sep" />
          <div className="hero-trust-item">
            <DollarSign size={15} className="hero-trust-icon" />
            <span>From $25 / visit</span>
          </div>
          <span className="hero-trust-sep" />
          <div className="hero-trust-item">
            <Wifi size={15} className="hero-trust-icon" />
            <span>No insurance needed</span>
          </div>
        </motion.div>

        <motion.div
          className="hero-image-wrapper"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          <img
            src="/images/hero-main-background.jpg"
            alt="Compassionate telehealth care"
            className="hero-image"
          />
          <div className="hero-image-overlay" />

          <div className="hero-stat hero-stat--left">
            <div className="hero-stat-number">6</div>
            <div className="hero-stat-label">Services available</div>
          </div>

          <div className="hero-stat hero-stat--right">
            <div className="hero-stat-number">$25</div>
            <div className="hero-stat-label">Starting price</div>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default Hero;
